document.addEventListener('DOMContentLoaded', function () {
  const eta_section = document.querySelectorAll('.eta-section');


  
    const min_express = document.querySelector('#express-start').dataset.days;
    const max_express = document.querySelector('#express-end').dataset.days;

    const min_express_new_value = document.querySelector('#express-start');
    const max_express_new_value = document.querySelector('#express-end');

    const expressEndMonth = document.querySelector('#expressEndMonth');
    const expressEndDay = document.querySelector('#expressEndDay');
    
    const currentDate = new Date();
  
    const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const currentDayIndex = currentDate.getDay();
    const currentDay = daysOfWeek[currentDayIndex];
  
    const futureDate = new Date(currentDate);
    const options = { weekday: 'short', month: 'short', day: 'numeric' };
    const month_option = { month: 'short' };
    const day_option = { day: 'numeric' };
    
    futureDate.setDate(currentDate.getDate() + parseInt(min_express));
    let min_express_new_value_formattedDate = futureDate.toLocaleDateString(undefined, options);
    min_express_new_value.textContent = min_express_new_value_formattedDate;
  
    futureDate.setDate(currentDate.getDate() + parseInt(max_express));
    let max_express_new_value_formattedDate = futureDate.toLocaleDateString(undefined, options);
    max_express_new_value.textContent = max_express_new_value_formattedDate;

    if(expressEndDay){
      expressEndDay.textContent = futureDate.toLocaleDateString(undefined, day_option);
    }
  
    if(expressEndMonth){
      expressEndMonth.textContent = futureDate.toLocaleDateString(undefined, month_option);
    }


  const tabButtons = document.querySelectorAll('.tab-button');
  const tabContents = document.querySelectorAll('.tab-content');

  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      // Remove 'active' class from all buttons and contents
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));

      // Add 'active' class to clicked button and corresponding content
      button.classList.add('active');
      const tabId = button.getAttribute('data-tab');
      document.getElementById(tabId).classList.add('active');
    });
  });
});